// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "firms span.letter {\n  padding-right: 5px;\n  cursor: pointer;\n}\nfirms #search {\n  width: 300px;\n}", ""]);
// Exports
module.exports = exports;
